import * as Scrivito from "scrivito";

import { toHtmlId } from "^/utils/toHtmlId";

export const HeadlineWidgetComponent = ({ widget }) => {
  const style = widget.get("style") || "h2";
  const level = widget.get("level") || style;
  const classNames = [style, "text-break", "hyphens-auto"];
  const currPage = Scrivito.currentPage();
  const textColor = widget.get("textColor");
  const anchor = toHtmlId(widget.get("anchor"));

  if (widget.get("alignment")) {
    classNames.push(
      `text-${
        widget.get("alignment") === "right" ? "end" : widget.get("alignment")
      }`
    );
  }
  if (widget.get("showMargin") === "no") {
    classNames.push("no-margin");
  }
  if (textColor) {
    classNames.push(`text-${textColor}`);
  }

  return (
    <Scrivito.ContentTag
      tag={level}
      content={widget}
      attribute="headline"
      className={classNames.join(" ")}
      lang={currPage.language() || currPage.siteId() || "de"}
      id={anchor || undefined}
    >
      {widget.get("showDividingLine") === "yes" ? (
        <span className="border-headline">{widget.get("headline")}</span>
      ) : (
        widget.get("headline")
      )}
    </Scrivito.ContentTag>
  );
};

Scrivito.provideComponent("HeadlineWidget", HeadlineWidgetComponent);
